import { getIn } from "@utils/index"
import * as R from "ramda"

const groupByPath = (path) =>
  R.pipe(
    R.reject((product: any) => R.isNil(R.prop(path[0])(product))),
    R.groupBy(R.view(R.lensPath(path)))
  )

export const groupByDeviceType = groupByPath(["device", "type", "slug"])

export const groupByDevice = groupByPath(["device", "slug"])

export const groupByBrandSlug = groupByPath(["brand", "slug"])

export const getGroupedMenuData = R.pipe(
  groupByDeviceType,
  R.map(groupByBrandSlug) as any
)

export const getUniqueDeviceTypes = R.pipe(
  R.map((product: any) => ({
    deviceType: getIn(product, "device.type"),
  })),
  R.uniq
)

export const getUniqueDevices = R.pipe(
  // @ts-ignore
  R.map(R.pick(["device", "brand"])),
  R.uniq
)
